import React from 'react';

import styles from './MainSection.module.css';

const MainSection = ({ fullWidth, children }) => {
  return <div className={`${styles.container} ${fullWidth ? styles.fullWidth : ''}`}>{children}</div>;
};

export default MainSection;
